import React from 'react'
// import '../../src/App.css'

const SpecialCases = () => {
  return (
    <>
      <div className="special-c">
        <div className="special-card">
        <i class="fa-solid fa-plus"></i>
        </div>
      </div>
    </>
  )
}

export default SpecialCases
